const getEnvVar = (key) => {
  const value = process.env[key];
  if (!value) return null;
  return value.trim();
};

const hostname =
  typeof window !== 'undefined' ? window.location.hostname.toLowerCase() : '';
const isStage = hostname.includes('verifypageonboarding');

export const DISCORD_CLIENT_ID = getEnvVar('REACT_APP_DISCORD_CLIENT_ID');

export const DISCORD_REDIRECT_URI =
  getEnvVar('REACT_APP_DISCORD_REDIRECT_URI') ||
  (isStage
    ? 'https://verifypageonboarding.nosoyliquidez.com/claim-role'
    : 'https://onboarding.nosoyliquidez.com/claim-role');

export const BACKEND_URL =
  getEnvVar('REACT_APP_BACKEND_URL') ||
  (isStage
    ? 'https://verifypage.nosoyliquidez.com'
    : 'https://www.nosoyliquidez.com');

const rawVideoUrl =
  getEnvVar('REACT_APP_ONBOARDING_VIDEO_URL') ||
  'https://iframe.mediadelivery.net/play/518337/a9d3e507-db74-4429-a25f-22bc746b7f78';

const separator = rawVideoUrl.includes('?') ? '&' : '?';
export const ONBOARDING_VIDEO_URL = `${rawVideoUrl}${separator}enable_api=true`;